export enum EFormaInclusaoItens {
    Automatica = 1,
    Manual = 2
}
